import { __assign } from "tslib";
var IGNORE_LIST = [
    // Wix
    /wix-style-react/,
    /cdn-wix.sessionstack.com/,
    // 3rd party
    /react-dom/,
    /googleapis.com/,
    // General
    /extensions\//i,
    /^chrome:\/\//i,
    // Answers
    /https:\/\/d2x3xhvgiqkx42\.cloudfront\.net/,
    /https:\/\/anstest-(.)+[.]wixanswers\.com/,
    /https:\/\/(.)+[.]devwixanswers\.com/,
    /https:\/\/answers-callcenter-testing(-.+)*.wixanswers\.com/ // ignore cc testing tenant
];
var IGNORE_ERRORS = [
    'ResizeObserver loop limit exceeded',
];
export var createSentryReporter = function (sentry, dsn) {
    return {
        setup: function (release, optionalSettings) {
            var initIgnoreErrors = (optionalSettings === null || optionalSettings === void 0 ? void 0 : optionalSettings.ignoreErrors) || [];
            var ignoreErrorsModified = initIgnoreErrors.concat(IGNORE_ERRORS);
            var options = __assign({ denyUrls: IGNORE_LIST, ignoreErrors: ignoreErrorsModified }, optionalSettings);
            sentry.init(__assign({ dsn: dsn,
                release: release, debug: process.env.NODE_ENV === 'development', environment: process.env.NODE_ENV }, options));
        },
        indentify: function (user) { return sentry.setUser({ email: user.email, username: user.fullName, id: user.id }); },
        reportError: function (e) { return sentry.captureException(e); },
        logMessage: function (msg) { return sentry.captureMessage(msg); },
        trackEvent: function (ev) { return sentry.addBreadcrumb(ev); },
        setTag: function (key, value) { return sentry.configureScope(function (scope) { return scope.setTag(key, value); }); }
    };
};
//# sourceMappingURL=index.js.map